import React, { useEffect, useRef, useState } from 'react';
import profile_icon from '../../assets/img/profile_icon.png';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Earning from './Earning';
import { useDispatch, useSelector } from 'react-redux';
import Manageservices from './Manageservices';
import Documentsnanny from './Documentsnanny';
import Contactus from './Contactus';
import { getNannyProfile } from '../../store/apiSlice/NannyprofileSlice';
import NeditProfile from './NeditProfile';
import Nannybooking from '../Nannybooking/Nannybooking';
import Availability from '../Availability/Availability';
import NannyPayments from './NannyPayments';
import StripeConnect from './StripeConnect';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { getNannyProfileStatus } from '../../store/apiSlice/NannyProfileStatusSlice';


const Profilenanny = () => {

    const dispatch = useDispatch();
    const profileData = useSelector((state) => state.rootReducer.nannyProfileReducer.data);
    const profileStatus = useSelector((state) => state.rootReducer.nannyProfileStatus.data);
    const toastShownRef = useRef(false);
    const [selectedIndex, setSelectedIndex] = useState(2);
    const [nannyProfile, setNannyProfile] = useState(null)
    const [visible, setVisible] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(getNannyProfile());
        dispatch(getNannyProfileStatus());
    }, []);

    useEffect(() => {
        if (profileData != null && profileData.status === 1) {
            setNannyProfile(profileData.data)
        }
        else if (profileData != null) {
            if (profileData.message && profileData.message === "Invalid token") {
                navigate('/login');
                window.location.reload();
            } else {
                alert(profileData.message)
            }
        }
    }, [profileData])

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
        }
        else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    window.addEventListener('scroll', toggleVisible);
    const handleTabChange = (index) => {
        // Allow Nanny without Connect
        // setSelectedIndex(index);
        // scrollToTop();

        // Allow Only Connected Nannies
        // if (nannyProfile && (nannyProfile?.isPaypalConnected === 0 && nannyProfile?.isStripeConnected === 0)) {
        //     if (index !== 2) {
        //         toast.error("Please connect at least one payment provider to proceed.");
        //     }
        //     return;
        // } else {
        //     setSelectedIndex(index);
        //     scrollToTop();
        // }
        setSelectedIndex(index);
        scrollToTop();
    };

    return (
        <>
            <div className="coustom_container">
                <div className='top-padding'>
                    {profileStatus?.data && (
                        <div style={{
                            marginBottom: '1.5rem',
                            padding: '1rem 1.25rem',
                            borderRadius: '10px',
                            backgroundColor: profileStatus.data.isFullyAvailable ? '#e8f9f0' : '#fff8e1',
                            border: `1px solid ${profileStatus.data.isFullyAvailable ? '#34c774' : '#f0ad4e'}`,
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.6rem' }}>
                                <span style={{ fontSize: '1.2rem' }}>
                                    {profileStatus.data.isFullyAvailable ? '✅' : '⚠️'}
                                </span>
                                <strong style={{ fontSize: '1rem', color: profileStatus.data.isFullyAvailable ? '#1a7f4b' : '#856404' }}>
                                    {profileStatus.data.isFullyAvailable
                                        ? 'Your profile is fully set up — you are visible to families!'
                                        : 'Complete the steps below to appear as available to families'}
                                </strong>
                            </div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem 1.5rem' }}>
                                {Object.entries({
                                    isAccountActive: 'Account active',
                                    isAdminVerified: 'Admin approved',
                                    isPaymentConnected: 'Payment connected',
                                    hasCategorySetUp: 'Service category added',
                                    hasAvailabilitySetUp: 'Availability set up',
                                }).map(([key, label]) => (
                                    <span key={key} style={{
                                        fontSize: '0.85rem',
                                        color: profileStatus.data.checks[key] ? '#1a7f4b' : '#b94a00',
                                        display: 'flex', alignItems: 'center', gap: '4px'
                                    }}>
                                        {profileStatus.data.checks[key] ? '✔' : '✘'} {label}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                    <Tabs selectedIndex={selectedIndex} onSelect={handleTabChange}>
                        <div className="row mb-5">
                            <div className="col-lg-3 mb-3 mb-md-0 h-100">
                                <div className="card  rounded overflow-hidden p-3 card_height">
                                    {nannyProfile != null &&
                                        <div className="profile_photo text-center p-2">
                                            <img src={nannyProfile != null && nannyProfile.profileImage != "" ? nannyProfile.profileImage : profile_icon} alt="profile" />
                                            <h4 className="mt-3">{nannyProfile.firstName} {nannyProfile.lastName}</h4>
                                        </div>
                                    }
                                    <TabList className="profile_edit_options profile_option_flex">
                                        <Tab className="profile_option" onClick={scrollToTop} >
                                            <span className="ms-0 ms-lg-2">My Booking</span>
                                        </Tab >
                                        <Tab className="profile_option" onClick={scrollToTop} >
                                            {/* <i className="fa fa-edit"></i> */}
                                            <span className="ms-0 ms-lg-2">My Profile</span>
                                        </Tab>
                                        <Tab className="profile_option" onClick={scrollToTop} >
                                            <span className="ms-0 ms-lg-2">Connect</span>
                                        </Tab>
                                        <Tab className="profile_option" onClick={scrollToTop} >
                                            <span className="ms-0 ms-lg-2">Earning</span>
                                        </Tab>
                                        <Tab className="profile_option" onClick={scrollToTop} >
                                            <span className="ms-0 ms-lg-2">Payments</span>
                                        </Tab>
                                        <Tab className="profile_option" onClick={scrollToTop} >
                                            <span className="ms-0 ms-lg-2">Manage Services</span>
                                        </Tab >
                                        <Tab className=" profile_option" onClick={scrollToTop} >
                                            <span className="ms-0 ms-lg-2">Documents</span>
                                        </Tab >
                                        <Tab className="profile_option" onClick={scrollToTop} >
                                            <span className="ms-0 ms-lg-2">Contact Us</span>
                                        </Tab >
                                        <Tab className="profile_option" onClick={scrollToTop} >
                                            <span className="ms-0 ms-lg-2">Availability</span>
                                        </Tab>
                                    </TabList >

                                </div>
                            </div >
                            <div className="col-lg-9">
                                <div className="card  rounded p-3 card_height">
                                    <TabPanel>
                                        <Nannybooking />
                                    </TabPanel>

                                    {/* <TabPanel>
                                        {nannyProfile !== null &&
                                            <Nannyprofile nannyData={nannyProfile} />
                                        }

                                    </TabPanel> */}

                                    <TabPanel>
                                        {nannyProfile !== null &&
                                            <NeditProfile nannyData={nannyProfile} />
                                        }
                                    </TabPanel>

                                    <TabPanel>
                                        {nannyProfile && <StripeConnect profile={nannyProfile} />}
                                    </TabPanel>

                                    <TabPanel>
                                        <Earning />
                                    </TabPanel>

                                    <TabPanel>
                                        <NannyPayments />
                                    </TabPanel>

                                    <TabPanel>
                                        <Manageservices />
                                    </TabPanel>

                                    <TabPanel>
                                        <Documentsnanny />
                                    </TabPanel>
                                    <TabPanel>
                                        <Contactus />
                                    </TabPanel>
                                    <TabPanel>
                                        <Availability />
                                    </TabPanel>
                                </div>
                            </div >
                        </div>
                    </Tabs>
                </div>
            </div >
        </>
    )
}

export default Profilenanny
